import { render, staticRenderFns } from "./pledge.vue?vue&type=template&id=58e7badf&scoped=true"
import script from "./pledge.vue?vue&type=script&lang=ts"
export * from "./pledge.vue?vue&type=script&lang=ts"
import style0 from "./pledge.vue?vue&type=style&index=0&id=58e7badf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7badf",
  null
  
)

export default component.exports